module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    class: _vm.belongs,
    style: ({
      width: _vm.btnW && (_vm.btnW + '').indexOf('%') > 0 ? _vm.btnW : _vm.btnW + 'px'
    }),
    attrs: {
      "disabled": _vm.btnDisable
    },
    on: {
      "click": function($event) {
        _vm.btnClick()
      }
    }
  }, [(_vm.loading && _vm.btnActive) ? _c('i', {
    staticClass: "icon-btn-loading",
    class: {
      active: _vm.btnActive
    }
  }) : _vm._e(), _vm._v(_vm._s(_vm.value) + "\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-905e65d4"}!./~/.11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/Buttons.vue
// module id = 74
// module chunks = 13